enum DYNAMIC_FIELDS_MAP {
  language = 'languageId',
  highschoolProfile = 'highschoolProfileId',
  highschool = 'highschoolId',
}

const IS_MULTIPLE_FIELDS = [
  'studentProfileLanguages',
  'studentHighschoolProfiles',
  'fieldsOfExpertise',
  'studentProfile',
  'offerLanguages',
  'offerHighschoolPrefs',
];

export const apiValidationHandler = (errors, setError, formData) => {
  try {
    Object.keys(errors).forEach((field) => {
      if (!field.includes('.')) {
        if (IS_MULTIPLE_FIELDS.includes(field)) {
          setError(`${field}Id`, { type: 'api', message: errors[field] });
        } else {
          setError(field, { type: 'api', message: errors[field] });
        }
      } else {
        const newKey = [];
        const splittedKey = field.split('.');
        splittedKey.forEach((key, index) => {
          if (index < splittedKey.length - 1) {
            if (IS_MULTIPLE_FIELDS.includes(key)) {
              const k = `${key}Attributes`;

              if (formData[k]) {
                if (Array.isArray(formData[k])) {
                  const multipleValuesLength = formData[k].length;
                  newKey.push(`${k}[${multipleValuesLength - 1}]`);
                } else if (Object.values(formData[k]).length) {
                  newKey.push(k);
                  const child = splittedKey[index + 1];
                  const childKey = `${child}Attributes`;

                  if (IS_MULTIPLE_FIELDS.includes(child)) {
                    const multipleValuesLength = formData[k][childKey].length;
                    newKey.push(`${childKey}[${multipleValuesLength - 1}]`);
                  } else {
                    newKey.push(childKey);
                  }
                }
              }
            } else {
              newKey.push(`${key}Attributes`);
            }
          } else {
            newKey.push(DYNAMIC_FIELDS_MAP[key] || key);
          }
        });
        const fieldName = newKey.join('.');

        setError(fieldName, { type: 'api', message: errors[field] });
      }
    });
  } catch (error) {
    console.debug(error); // eslint-disable-line
  }
};

type PrepareFormData = (data, prefix?: string | null) => FormData;

export const prepareFormData: PrepareFormData = (data, prefix = '') => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    const formDataKey = prefix ? `${prefix}[${key}]` : key;
    if (key === 'field') {
      formData.append(formDataKey, data[key][1]);
    } else {
      formData.append(formDataKey, data[key]);
    }
  });

  return formData;
};

export default apiValidationHandler;
